import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FaCog } from 'react-icons/fa';
import cdrFilesService from '../../services/cdrFilesService';

const CdrFilesServerWarning = ({ cdrFilesServerAvailable }) => {
  const [showModal, setShowModal] = useState(false);
  const [urlValue, setUrlValue] = useState('');

  // Открываем модалку — читаем текущее значение
  const handleOpenModal = () => {
    const current = cdrFilesService.GetCdrfilesServerURL() || '';
    setUrlValue(current);
    setShowModal(true);
  };

  const handleSave = () => {
    cdrFilesService.SetCdrfilesServerURL(urlValue.trim());
    setShowModal(false);
    // Опционально: перезагрузить страницу, чтобы подтянулся новый URL
    window.location.reload();
  };

  const handleReset = () => {
    // если нужно вернуть значение по умолчанию — можно очистить ключ
    localStorage.removeItem('cdrfiles_server_url');
    setUrlValue(cdrFilesService.GetCdrfilesServerURL() || '');
  };

  if (cdrFilesServerAvailable !== false) return null;

  return (
    <>
      <div className="text-danger my-3 d-flex align-items-center flex-wrap" style={{ gap: 8 }}>
        <span>Сервер макетов недоступен.</span>
        <span>
          Проверьте подключение{' '}
          <a href={cdrFilesService.getHealthUrl()}>{cdrFilesService.getHealthUrl()}</a>
        </span>
        <FaCog
          role="button"
          title="Настройки сервера макетов"
          style={{ cursor: 'pointer' }}
          onClick={handleOpenModal}
        />
      </div>

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Настройки сервера макетов</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>URL сервера макетов</Form.Label>
            <Form.Control
              type="text"
              value={urlValue}
              onChange={(e) => setUrlValue(e.target.value)}
              placeholder="http://localhost:5000"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleReset}>
            Сбросить
          </Button>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Отмена
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Сохранить
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CdrFilesServerWarning;